<template>
    <div style="width: 100%; position: relative;">
        <van-image width="100%" height="108px" fit="cover" :src="require('@/assets/orderBg.jpg')"/>
        <div style="height: 108px; padding: 15px 20px; position: absolute; top: 0; color: white;">
            <div style="font-size: 20px; font-weight: bold;">{{detail.prodName}}</div>
            <div style="font-size: 14px; margin: 10px 0 5px 0; color: #DDDDDD;">保单号：{{detail.bxOrderNo}}</div>
            <div style="font-size: 14px; color: #DDDDDD;">由平安保险承保</div>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; background-color: white; margin: 0 0 1px 0;">
            <div style="">保障内容</div>
            <div style="font-size: 14px"></div>
        </div>
        <div style="padding: 5px 0; background-color: white;">
            <div class="orderItemContent" v-for="(item,index) in prodInfo.prodInfo" :key="index">
                <div>{{item.prodLabel}}</div>
                <div style="margin-left: 20px;">{{item.prodInfo}}</div>
            </div>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; background-color: white; margin: 8px 0 1px 0;">
            <div style="">投保人</div>
            <div style="font-size: 14px">{{detail.principalName}}</div>
        </div>
        <div style="padding: 5px 0; background-color: white;">
            <div class="orderItemContent">
                <div>身份证</div>
                <div>{{detail.principalIdCard}}</div>
            </div>
            <div class="orderItemContent">
                <div>手机号</div>
                <div>{{detail.principalPhone}}</div>
            </div>
            <div class="orderItemContent">
                <div>邮箱</div>
                <div>{{detail.principalEmail}}</div>
            </div>
        </div>


        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; background-color: white; margin: 8px 0 1px 0;">
            <div style="">被保人</div>
            <div style="font-size: 14px">{{userBuy.joinName}}</div>
        </div>
        <div style="padding: 5px 0; background-color: white;">
            <div class="orderItemContent">
                <div>证件类型</div>
                <div>身份证</div>
            </div>
            <div class="orderItemContent">
                <div>证件号</div>
                <div>{{userBuy.joinIdCard}}</div>
            </div>
        </div>


        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; background-color: white; margin: 8px 0 1px 0;">
            <div style="">保单信息</div>
            <div style="font-size: 14px"></div>
        </div>
        <div style="padding: 5px 0; background-color: white;">
            <div class="orderItemContent">
                <div>保费</div>
                <div>{{detail.amount/100}}元</div>
            </div>
            <div class="orderItemContent">
                <div>保障期限</div>
                <div>{{detail.effectiveDate|dateFormat('YYYY-MM-DD')}}至{{detail.deadline|dateFormat('YYYY-MM-DD')}}</div>
            </div>
        </div>

<!--        <div style="text-align: center; margin-top: 8px; background-color: white; font-size: 12px; padding: 10px 20px; color: #1C7CF8;">-->
<!--            保险条款-->
<!--        </div>-->
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Image);

    export default {
        name: "OrderDetail",
        data() {
            return {
                id: this.$route.query.id,
                prodInfo: {prodInfo:{prodInfo:[]}},
                userBuy: {},
                detail:{}
            }
        },
        created() {
            this.$axios.get("/order/detail", {params: {userBuyId: this.id}}).then(res => {
                this.prodInfo = res.data.prodInfo
                this.userBuy = res.data.userBuy
                this.detail = res.data.detail
            });
        },
        methods: {}
    }
</script>

<style>
    .orderItemContent {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: #666666;
        font-size: 12px;
        padding: 5px 20px;
        background-color: white;
    }
</style>
